<template>
  <v-container fluid class="pa-0 ma-0" style="height:inherit">
    <iframe class="checklistframe" v-if="checklistUrl" :src="checklistUrl" width="100%" height="100%"></iframe>
  </v-container>
</template>


<script>
export default {
  name: "ViewCheckLists",
  data() {
    return {
      checklistUrl: null
    }
  },
  mounted() {
    this.checklistUrl = "/checklist/#/open-abcdef/job/" + this.$route.params.jobId
    console.log(this.checklistUrl);
  }
};
</script>

<style lang="scss" scoped>
  .checklistframe {
    border: none;
    padding: 0;
    margin: 0;
  }
</style>